import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "& > div": {
      top: 0,
    },
  },
  sectionMargin: {
    marginTop: theme.hv.spacing.md,
    outline: "none",
  },
  loading: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100vh",
  },
  zIndex: {
    // We need to set this nonsense value to make sure the loading overlays all HVS page elements.
    zIndex: 9999999999,
  },
}));

export default useStyles;
